import React from "react";
import useGuardianshipBondRetrieve from "./hooks/useGuardianshipBondRetrieve";
import { BOND_RETRIEVE_PAGE_SECTIONS } from "./bondRetrievePageSections";
import { BondRetrievalShell } from "./components/bondRetrieval/BondRetrievalShell";
import {
  formatCorrectionFieldLabel,
  formatCorrectionFromTo,
  uploadToADLS,
} from "./components/GuardianshipBondRetrieveHelpers";

const VermostGuardianshipBondRetrieveForm = () => {
  const hookState = useGuardianshipBondRetrieve();
  const sectionConfig = BOND_RETRIEVE_PAGE_SECTIONS.guardianship;
  const pageCtx = {
    globalState: hookState.globalState,
    updateGlobalState: hookState.updateGlobalState,
    role: hookState.role,
    disabled: hookState.disabled,
    data: hookState.data,
    userdetails: hookState.userdetails,
    bond_id: hookState.bond_id,
  };

  return (
    <BondRetrievalShell
      kind="guardianship"
      sectionConfig={sectionConfig}
      pageCtx={pageCtx}
      onSubmitDataCorrection={hookState.handleSubmitDataCorrection}
      formatCorrectionFieldLabel={formatCorrectionFieldLabel}
      formatCorrectionFromTo={formatCorrectionFromTo}
      uploadToADLS={uploadToADLS}
      {...hookState}
    />
  );
};

export default VermostGuardianshipBondRetrieveForm;
